var React = require('react');

function BookmarkOutline12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 0.5C2.44772 0.5 2 0.947715 2 1.5V11.5L6 8.9L10 11.5V1.5C10 0.947715 9.55228 0.5 9 0.5H3ZM3.25 1.75V9.2L6 7.41L8.75 9.2V1.75H3.25Z","fill":"currentColor"}));
}

BookmarkOutline12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = BookmarkOutline12;

BookmarkOutline12.default = BookmarkOutline12;
